/**
 * Magic MRS Client 사용자 제공 JS
 * 
 * - exportPopup.html 에서 임포트
 * - importPopup.html 에서 임포트
 */
console.log("MagicMRS.js 임포트");

document.addEventListener('DOMContentLoaded', () => {
    console.log("DOMContentLoaded 호출");
    // 이미 iframe 생성되어 있으면 제거 후 새로 생성
    if(document.getElementById('dsmrsContainer')) {
        MagicMRS.removeIframe();
    }
    MagicMRS.initIframe();
    MagicMRS.loadHtml();
});

const __loadScript__ = (url, callback) => {
    let script = document.getElementById('ml5');
    if (!script) script = document.createElement('script');
    // TODO : MLMain.html iframe 삭제 (확인 필요)
    if (document.getElementById('dscert')) {
        document.getElementById('dscert').remove();
    }
    // TODO : MLMain.html iframe 삭제 (확인 필요)
    if (document.getElementById('dscertContainer')) {
        document.getElementById('dscertContainer').remove();
    }
    script.id = 'ml5';
    script.src = url;
    
    script.onload = () => {
        if (callback) callback();
    }

    document.body.appendChild(script);
}

const __getMainHtmlPathString__ = () => {
    let magicmrsv2PathString = "";
    let scriptMagicmrsv2Path = document.getElementById("magicmrsv2").src;
    let splitMagicmrsv2Path = scriptMagicmrsv2Path.split("/");
    // 0 - 2 까지는 프로토콜 도메인(:포트) 영역 해당 부분 이후 부터 조림하여 사용하면 됨
    let totalPathCnt = splitMagicmrsv2Path.length;
    let startPathCnt = 3;
    let prePathCnt = 1;
    let middlePathCnt = totalPathCnt - startPathCnt - prePathCnt;
    let preOriginUrl = splitMagicmrsv2Path[0]+"//"+splitMagicmrsv2Path[2]; // origin 값

    /**
     * MLMain.html 로딩 시 인자 값으로 현재 사용할 날짜 값을 생성한다.
     * 
     * @returns 년월일 값 
     */
    const getYYYYMMDD = () => {
        let currentDate = new Date();
        let yyyy = currentDate.getFullYear();
        let mm = currentDate.getMonth()+1; // getMonth() is zero-based
        let dd  = currentDate.getDate();
        return String(10000*yyyy + 100*mm + dd); // Leading zeros for mm and dd
    }
    
    if (middlePathCnt > 0) {
        for (let i = startPathCnt; i < startPathCnt + middlePathCnt; i++) {
            magicmrsv2PathString = magicmrsv2PathString + "/" + splitMagicmrsv2Path[i];
        }
    }
    /** 날짜값 추가 */
    magicmrsv2PathString = magicmrsv2PathString + "/MRSMain.html?" + getYYYYMMDD();
    return magicmrsv2PathString;
}

// 클로저를 이용하여 Private 클래스 생성
// 주의 사항:
// 화살표 함수를 사용하면, 클로저 함수내에서 this를 사용할 수 없다. 주의 필요.
// (화살표 함수는 자체적인 this를 가지지 않는다. 화살표 함수는 선언된 시점의 상위 스코프의 this를 그대로 사용...)
const MagicMRS = (function async () {

    let callback = "";

    const targetOrigin = window.location.protocol + "//" + window.location.hostname + (window.location.port? ':'+window.location.port: '');

    // iframe 속성 설정 함수
    const setIframeAttributes = (iframe, config) => {
        for(let key in config){
            if(config.hasOwnProperty(key)) {
                let value = config[key];
                iframe.setAttribute(key, value);
            }
        }
    };

    const moveLastFocusedElement = () => {
        if (MagicMRS.lastFocusedElement && MagicMRS.lastFocusedElement != ""
        && document.getElementById(MagicMRS.lastFocusedElement)
        ) {
            document.getElementById(MagicMRS.lastFocusedElement).focus();
        }
    }

    return {
        iframeConfigs: {
            id: 'dsmrs',
            name: 'dsmrs',
            title: 'dsmrs',
            src: __getMainHtmlPathString__(),
            scrolling: 'no',
            width: '100%',
            height: '100%',
            frameBorder: '0',
            allowTransparency: 'true',
            translate: 'yes',
            style: 'position:fixed; z-index:100010; top:0px; left:0px; width:100%; height:100%;'
        },
        lastFocusedElement: "",
        addEventListener() {
            if (window.addEventListener) {
                window.addEventListener('message', this.eventHandler, false);
            } else if (window.attachEvent) {
                window.attachEvent('onmessage', this.eventHandler);
            }
        },
        eventHandler(event) {
            // console.log("MagicMRS.eventHandler - 자식으로 부터 PostMessage 이벤트 받음");
            if (event.origin !== targetOrigin) return; // postMessage 의 target origin 검증
            let childMessage = event.data;
            // MagicMRS Message 확인 (다른 외부 어플리케이션에서 message 이벤트 발생할 경우 방어 코드)
            if (childMessage == null || childMessage.sender !== 'MagicMRS') return;

            if (childMessage.key === 'initML5') {
                console.log("initML5 호출");
                if (!childMessage.data
                    || !childMessage.data.magiclinePath
                    || !childMessage.data.configPath
                ) {
                    throw new Error("Ml5.build.js 경로를 가져올수없습니다.");
                }
                let ml5Path = childMessage.data.magiclinePath;
                let configPath = childMessage.data.configPath;
                
                __loadScript__(ml5Path, () => {
                    // index.html 파일에 script 테그로 javascript 임포트 하지 않는경우
                    // document.addEventListener 함수가 실행하지 않아 직접 하위 내용 실행
                    setTimeout(() => {
                            if(document.getElementById("dscertContainer")){
                                ML5.removeIframe();
                            }
                            ML5.setConfig(configPath);
                            ML5.initIframe(); // iframe 속성 값 / UI 영역 셋팅
                    }, 100);
                });
            } else if (childMessage.key === 'showImportCertModal') {
                let path = (typeof ML5 !== "undefined")? ML5.downloadPath : "";
                MagicMRS.sendToChildPostMessage({"key": "importCert", "data": path}, callback);
            } else if (childMessage.key === 'showMRSContainer') {
                document.getElementById('dsmrsContainer').style.display = 'block';
            } else if (childMessage.key === 'showMLContainer') {
                if (!ML5) {
                    console.log("ML5 undefined.");
                    return;
                }
                const _type = "pkcs7";
                const _originalData = "mrs";
                const _config = ""; // childMessage.data.config
                if (this.lastFocusedElement && this.lastFocusedElement != "" && document.getElementById(this.lastFocusedElement)) {
                    ML5.setFocusAfterClosed(this.lastFocusedElement);
                } // 웹 접근성 focus 처리
                ML5.open(_type, _originalData, _config, (code, response) => {
                    if (code === 0) { // 인증서 정보 가져오기 성공.
                        MagicMRS.sendToChildPostMessage({"key": "export", "data": response}, callback);
                    }
                    else {
                        if (typeof callback === 'function') {
                            callback(3002, "fail");
                        } else {
                            console.log("[MagicMRS:info] ML5 인증서 정보 가져오기 실패.");
                        }
                    }
                });
                
            } else if (childMessage.key === 'closeModal') {
                if (typeof callback === 'function') {
                    callback(childMessage.code, childMessage.resultMsg);
                } else {
                    console.error(childMessage.code + ": " + childMessage.resultMsg);
                }
                moveLastFocusedElement(); // 웹 접근성 포커스 이동
            } else {
                document.getElementById('dsmrsContainer').style.display = 'none'; // import2의 경우 다음 팝업(import_save)을 띄워야하는데 닫혀버림
                if (typeof callback === 'function') {
                    callback(childMessage.code, childMessage.resultMsg);
                } else {
                    console.error(childMessage.code + ": " + childMessage.resultMsg);
                }
                moveLastFocusedElement(); // 웹 접근성 포커스 이동
            }
        },
        initIframe() {
            console.log("initIframe 시작");
            const body = document.body;
            const div = document.createElement('div');
            const iframe = document.createElement('iframe');

            // iframe attributes(iframeConfigs) 추가
            setIframeAttributes(iframe, this.iframeConfigs);
            iframe.onload = () => { };

            div.id = 'dsmrsContainer';
            div.style.display = 'none';
            div.appendChild(iframe);

            if (!document.getElementById('dsmrsContainer')) {
                body.appendChild(div);
            }
        },
        removeIframe() {
            console.log("iframe 제거 함수 호출");
            const div = document.getElementById('dsmrsContainer');
            if (div) {
                div.remove();
            }
        },
        loadHtml(callback) {
            this.addEventListener(callback);
        },
        /**
         * 
         * @param {object} param 
         * @param {string} param.key operation code
         * @param {object} param.data parameter data
         * @param {function} callback 
         */
        open: function (param, callback) {
            if (!param) {
                console.log("MagicMRS.open - 파라미터 값 NULL.");
                return;
            }

            document.getElementById('dsmrsContainer').style.display = 'none';
            this.sendToChildPostMessage(param, callback)
        },
        sendToChildPostMessage(message, _callback) {
            callback = _callback;
            this.addEventListener(callback);
            let iframeWindow = document.getElementById('dsmrs').contentWindow;
            iframeWindow.postMessage(message, targetOrigin);
        },
    };
})();